import React, { FC } from "react";

import classNames from "classnames";

import styles from "./ResaleParticipantDetails.module.scss";

interface ResaleParticipantDetailsProps {
  companyName?: string;
  reporter?: string;
  isExternalUser: boolean;
}

export const ResaleParticipantDetails: FC<ResaleParticipantDetailsProps> = ({
  companyName,
  reporter,
  isExternalUser,
}) => {
  const displayReporter =
    isExternalUser && reporter?.toUpperCase().startsWith("NRRS") ? "X" : reporter || <i>No Reporter</i>;

  return (
    <div>
      <div className={classNames(styles["company"], "b3 bold")}>{companyName || "Unknown Company"}</div>
      <div className={classNames(styles["reporter"], "b4")}>{displayReporter}</div>
    </div>
  );
};
